import { useEffect, useRef } from 'react';

// Hook to simulate componentDidUpdate(),
// This hook doens't run the first time this function is called
const useDidMountEffect = (callback: () => void, deps: unknown[]) => {
  const didMount = useRef(false);
  useEffect(() => {
    if (didMount.current) {
      callback();
    } else {
      didMount.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useDidMountEffect;
